import * as Actions from '../actions'

const initialState = {
  data: []
}

const deeplinkReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_DEEPLINK:
      {
        return {
          ...state,
          data: action.payload
        }
      }
    default:
      {
        return state
      }
  }
}

export default deeplinkReducer